export function getValueInObject(obj, dotPath) {
  if (typeof obj === 'object' && obj !== null) {
    if (dotPath.indexOf('.') > -1) {
      return dotPath.split('.').reduce((acc, curr) => {
        if (typeof acc[curr] === 'undefined') {
          return acc;
        }

        return acc[curr];
      }, obj);
    }
    return obj[dotPath];
  }
  throw new Error(`Variable must be an object. Can't resolve "${dotPath}" path`);
}

const OBJ_SORT_TYPES = {
  asc(key) {
    return (a, b) => {
      if (getValueInObject(a, key) < getValueInObject(b, key)) {
        return -1;
      }
      if (getValueInObject(a, key) > getValueInObject(b, key)) {
        return 1;
      }
      return 0;
    };
  },

  desc(key) {
    return (a, b) => {
      if (getValueInObject(a, key) < getValueInObject(b, key)) return 1;
      if (getValueInObject(a, key) > getValueInObject(b, key)) return -1;
      return 0;
    };
  },
};

export function sortArrayOfObjects(array, sortDirection, sortKey) {
  return array.sort(OBJ_SORT_TYPES[sortDirection](sortKey));
}
